import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Select, Button, Radio, InputNumber} from 'antd'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

@inject('marketingManagementStore')
@observer
class GroupModal extends Component {
  state = {
    configTypeValue: '',
  }

  formRef = React.createRef()

  handleOk = () => {
    const {marketingManagementStore, handleCancel, record} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      marketingManagementStore.groupLogSave({...fieldsValue, marketGroupId: record.id}).then(res => {
        if (res?.code === 0) {
          handleCancel()
        }
      })
    }).catch(() => {})
  }

  render() {
    const {marketingManagementStore, addModalVisible, handleCancel, t} = this.props
    const {isGroupFetching} = marketingManagementStore
    return (
      <>
        <Modal
          title="分组调整"
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'40%'}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} loading={isGroupFetching}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[20, 10]}>
              <Col span={12}>
                <Form.Item name="configType" label="配置类型" rules={[{required: true}]}>
                  <Select placeholder="请选择" allowClear onChange={value => this.setState({configTypeValue: value})}>
                    <Select.Option key="1" value="1">营销短信</Select.Option>
                    <Select.Option key="2" value="2">通知短信</Select.Option>
                    <Select.Option key="3" value="3">邮件</Select.Option>
                    <Select.Option key="4" value="4">外呼 </Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="actionType" label="操作类型" initialValue="1">
                  <Radio.Group style={{display: 'flex'}}>
                    <Radio value="1">增加</Radio>
                    <Radio value="2">扣除</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name={this.state.configTypeValue === "4" ? "callBalance" : "number"} label={this.state.configTypeValue === "4" ? "余额" : "额度"} rules={[{required: true}]}>
                  <InputNumber min={0} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="remark" label="备注">
                  <TextArea rows={4}/>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(GroupModal)
